export const createPathForPremiumPopup = path => {
  // do check to avoid /path/premiumpopup/premiumpopup
  return path.match(/\/premiumpopup$/) ? path : `${path}/premiumpopup`
}

export const getContextOfPremiumPopup = path => {
  // use `g` flag to cater to /path/premiumpopup/premiumpopup
  return path.replace(/\/premiumpopup/g, '')
}
